import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=3654a907&"
import script from "./CreateModal.vue?vue&type=script&lang=js&"
export * from "./CreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3654a907')) {
      api.createRecord('3654a907', component.options)
    } else {
      api.reload('3654a907', component.options)
    }
    module.hot.accept("./CreateModal.vue?vue&type=template&id=3654a907&", function () {
      api.rerender('3654a907', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/CreateModal.vue"
export default component.exports